












import Vue from "vue";
import {Component, Prop} from "vue-property-decorator";
import RadialChart from "@/components/layout/charts/radial/RadialChart.vue";
import LineChart from "@/components/layout/charts/line/LineChart.vue";
import ContentCard from "@/components/layout/cards/ContentCard.vue";

@Component({
  components: {
    "content-card": ContentCard,
    "radial-chart": RadialChart,
    "line-chart": LineChart,
  },
})
export default class TrendCard extends Vue {
  @Prop()
  private readonly title!: string;
}
